<template>
    <div class="form-control">
        <label class="label"><span class="label-text">{{ label }}</span></label>
        <multi-select :value="value" :options="options" @input="$emit('input', $event)" />
    </div>
</template>

<script>
import MultiSelect from '@/components/iview/MultiSelect'

export default {
    name: 'FieldMultiSelect',
    components: { MultiSelect },
    props: {
        value: { type: Array, default: () => [] },
        options: { type: Array, default: () => [] },
        label: { type: String, default: '' }
    }
}
</script>
